import CheckIcon from '@mui/icons-material/Check'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { IconButton, Tooltip } from '@mui/material'
import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

interface CopyButtonProps {
  value: string
  label?: string
  size?: number
}

export const CopyButton = ({ value, label, size = 14 }: CopyButtonProps) => {
  const { t } = useTranslation()
  const [copied, setCopied] = useState(false)

  const handleCopy = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation()
      void navigator.clipboard.writeText(value).then(() => {
        setCopied(true)
        setTimeout(() => setCopied(false), 1500)
      })
    },
    [value],
  )

  return (
    <Tooltip title={copied ? t('common.copied') : (label ?? t('common.copy'))}>
      <IconButton size="small" onClick={handleCopy} sx={{ flexShrink: 0, p: 0.25 }}>
        {copied ? (
          <CheckIcon sx={{ fontSize: size }} color="success" />
        ) : (
          <ContentCopyIcon sx={{ fontSize: size }} />
        )}
      </IconButton>
    </Tooltip>
  )
}
